export const MANDATORY_CPD_LABEL = 'Mandatory CPD';
export const UNKNOWN_LABEL = 'Unknown';
